<template>
  <slot></slot>
</template>

<script>
export default {
  name: "MenuScroll",
  data() {
    return {
      delay: false,
      navbar: null,
      contentContainer: null,
      navbarOpen: true
    };
  },
  mounted(){
    this.$nextTick(()=>{
      this.navbar = document.getElementById("navbar-inside");
      this.contentContainer = document.getElementById("content-container");
    });

    window.addEventListener('scroll',this.scrollFunction);
    window.addEventListener('resize', this.resizeFunction);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeFunction);
    window.removeEventListener('scroll',this.scrollFunction);
  },
  methods: {
    resizeFunction(){
      // if(this.delay) {
      //   return;
      // }
      let width = window.innerWidth;


      if(width <= 1367) {
        if(this.navbarOpen){
          this.contentContainer.style.marginTop = "11.6rem";
        } else{
          this.contentContainer.style.marginTop = "7.1rem";
        }
      }
      else {
        if(this.navbarOpen){
          this.contentContainer.style.marginTop = "12.6rem";
        } else{
          this.contentContainer.style.marginTop = "6.3rem";
        }
      }

      // this.delay = true;
      // setTimeout(() => {
      //   this.delay = false;
      // }, 1000);
    },
    scrollFunction() {
      let scrollTop = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      if (this.navbarOpen && scrollTop > 0) {
        // this.navbar.style.height = "20%";
        this.navbar.style.minHeight = "50px";
          this.navbar.style.maxHeight = "50px";

          this.navbarOpen = false;
        this.resizeFunction();
      } else if(scrollTop === 0 && !this.navbarOpen) {
        this.navbar.style.height = null;
        this.navbar.style.minHeight = null;
          this.navbar.style.maxHeight = null;

          this.navbarOpen = true;
        this.resizeFunction();

      }
    }
  }
}
</script>